<template>
  <v-container fluid class="user-edit mt-3 mx-1">
    <v-row>
        <v-col cols="12">
            <v-tabs
                color="primary"
                centered
            >
                <v-tabs-slider></v-tabs-slider>

                <v-tab
                    :href="`#tab-account`"
                    class="mr-5"
                >
                    <v-icon class="mr-3">mdi-shield-account-variant-outline</v-icon>
                    Аккаунт
                </v-tab>
                <v-tab
                    class="mr-5"
                    :href="`#tab-password`"
                >
                    <v-icon class="mr-3">mdi-lock</v-icon>
                    Изменение пароля
                </v-tab>
                <v-tab
                    :href="`#tab-email`"
                >
                    <v-icon class="mr-3">mdi-cog</v-icon>
                    Изменение email
                </v-tab>
                <v-tab-item
                    :value="'tab-account'"
                >
                    <v-card
                        elevation="0"
                        flat
                        tile
                    >
                        <v-card-text>
                            <v-row justify="center">
                                <v-col cols="12" md="6">
                                    <user-profile></user-profile>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <v-tab-item
                    :value="'tab-password'"
                >
                    <v-card
                        flat
                        tile
                    >
                        <v-card-text>
                            <v-row justify="center">
                                <v-col cols="12" md="6">
                                    <change-password></change-password>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <v-tab-item
                    :value="'tab-email'"
                >
                    <v-card
                        flat
                        tile
                    >
                        <v-card-text>
                            <v-row justify="center">
                                <v-col cols="12" md="6">
                                    <change-email></change-email>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UserProfile from './UserProfile.vue';
import ChangePassword from './ChangePassword.vue';
import ChangeEmail from './ChangeEmail.vue';
export default {
    name: 'ProfileEdit',
    components:{
        UserProfile, ChangePassword, ChangeEmail
    },
    data () {
        return {

        }
    },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
